var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useRef, useState } from 'react';
export default function useFullscreen({ targetRef, onEnter, onExit }) {
    const [isFullScreen, setIsFullScreen] = useState(() => !!document.fullscreenElement);
    const prevIsFsRef = useRef(!!document.fullscreenElement);
    const requestFullscreen = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const el = (_a = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) !== null && _a !== void 0 ? _a : document.documentElement;
        if (!el)
            return;
        try {
            yield ((_c = (_b = el).requestFullscreen) === null || _c === void 0 ? void 0 : _c.call(_b));
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('[useFullscreen] request error:', err);
        }
    }), [targetRef]);
    const exitFullscreen = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (!document.fullscreenElement)
            return;
        try {
            yield ((_a = document.exitFullscreen) === null || _a === void 0 ? void 0 : _a.call(document));
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('[useFullscreen] exit error:', err);
        }
    }), []);
    const toggleFullScreen = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (document.fullscreenElement) {
            yield exitFullscreen();
        }
        else {
            yield requestFullscreen();
        }
    }), [exitFullscreen, requestFullscreen]);
    useEffect(() => {
        const onChange = () => {
            const isFs = !!document.fullscreenElement;
            setIsFullScreen(isFs);
            // вызывать колбеки только при реальном изменении состояния
            if (isFs && !prevIsFsRef.current) {
                onEnter === null || onEnter === void 0 ? void 0 : onEnter();
            }
            else if (!isFs && prevIsFsRef.current) {
                onExit === null || onExit === void 0 ? void 0 : onExit();
            }
            prevIsFsRef.current = isFs;
        };
        document.addEventListener('fullscreenchange', onChange);
        return () => document.removeEventListener('fullscreenchange', onChange);
    }, [onEnter, onExit]);
    return { isFullScreen, requestFullscreen, exitFullscreen, toggleFullScreen };
}
